import { Component, OnInit, Input, ElementRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DashboardQueries } from '../../../shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '../../../shared/models/WidgetSearch';
import { DashboardService } from '../../../shared/services/dashboard.service';
import { GlobalsService } from '../../../shared/services/globals.service';
import { Subscription } from 'rxjs';

import { DashboardWidgetService } from '../../../shared/services/dashboardWidget.service';
//import { Item } from '@progress/kendo-angular-grid/dist/es2015/data/data.iterators';
import { filterItem } from '@app/cp/shared/models/filterItem';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DataItem } from '@progress/kendo-angular-grid';
import { FeatureFlagService } from '@app/cp/shared/services/feature-flag.service';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';

@Component({
    selector: 'cp-dispatch-status-gauge',
    templateUrl: './dispatch-status-gauge.component.html',
    styleUrls: ['./dispatch-status-gauge.component.scss']
})
export class DispatchStatusGaugeComponent implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];

    constructor(private globals: GlobalsService, private svc_data: DashboardService, qry_rd: DQOIReferenceDataQuery, private featureFlagService: FeatureFlagService) {
        this.qry_rd = qry_rd;

    }

    customerFilters: any;
    acctClassFilters: any;
    srvConstFilters: any;
    billerFilters: any;
    daysAgedFilters: any;
    dispatchStatusFilters: any;
    locationsFilters: any;
    divisionFilters: any;
    regionFilters: any;
    defaultSubmitterFilters: any;
    discreetBillerFilters: any;

    @Input() chartType: string = 'donut';
    @Input() detailsTitleStart: string = '';
    @Input() inputSearchParams: WidgetSearch;
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);
    subs_dataRefUpdated: Subscription;
    widgetQuery: DashboardQueries = DashboardQueries.dispatchStatusGauge;
    //evaluate the feature flag to determine filters
    chartSearchFilters: widgetFilters[];

    private setWidgetFilters() {
        this.chartSearchFilters = this.featureFlagSet["days-aged-widget-filter"] ?
            [
                widgetFilters.customer,
                widgetFilters.svcConst,
                widgetFilters.locations,
                widgetFilters.divisions,
                widgetFilters.regions,
                widgetFilters.class,
                widgetFilters.priority,
                widgetFilters.biller,
                widgetFilters.status,
                widgetFilters.discreetBiller,
                widgetFilters.defaultSubmitter,
                widgetFilters.daysAged
            ]
            :
            [
                widgetFilters.customer,
                widgetFilters.svcConst,
                widgetFilters.locations,
                widgetFilters.divisions,
                widgetFilters.regions,
                widgetFilters.class,
                widgetFilters.priority,
                widgetFilters.biller,
                widgetFilters.status,
                widgetFilters.discreetBiller,
                widgetFilters.defaultSubmitter
            ];
    }

    show: boolean = false;
    searchParam: WidgetSearch;
    data: DataItem[];
    gridData: any;

    detailsTitle: string;
    detailsActive: boolean = false;
    selectedFilters: WidgetSearch;
    public windowData: any = {};
    public showDetails: boolean = false;
    public showWindow: boolean = false;
    public activeChildComp: number;
    public contentTypes = WindowContents;
    public dashboardQuery: DashboardQueries = DashboardQueries.dispatchStatusGauge;

    public collision = { horizontal: "flip", vertical: "fit" };

    subs_dataRef: Subscription;
    qry_rd: DQOIReferenceDataQuery;
    referenceData: DQOIReferenceData;
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();

    loaderError: boolean = false;
    private subs_featureFlagSet: Subscription; //place as class variable
    featureFlagSet = {};

    ngOnInit() {
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.subs_dataRefUpdated = this.qry_rd.referenceDataUpdated.subscribe((data: DQOIReferenceData) => {
            this.referenceData = data;
        });
        this.subscriptions.push(this.svc_data.refreshTrigger$.subscribe(
            refresh => {
                if (this.searchParam) {
                    this.search(this.searchParam);
                }
            }));
        if (this.inputSearchParams) {
            this.searchParam = this.inputSearchParams;
        }
        this.subs_featureFlagSet = this.featureFlagService.featureFlagSets.subscribe((data: any) => {
            this.featureFlagSet = data;
            this.setWidgetFilters();
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
        CommonFunctions.unsubscribe(this.subs_featureFlagSet); //place in ngOnDestroy
        CommonFunctions.unsubscribe(this.subs_dataRef);
        CommonFunctions.unsubscribe(this.subs_dataRefUpdated);
    }
    getData() {
        this.search(this.searchParam);
    }
    search(searchParam: WidgetSearch) {
        this.hideError();
        this.searchParam = searchParam;
        this.searchParams.emit(searchParam);
        this.searchParam.userId = this.globals.userId;
        if (this.searchParam.customSearch || this.searchParam.emptySearch) {
            this.show = false;
            this.showSpinner();
            this.svc_data.getDashboardQuery(this.widgetQuery, this.searchParam).subscribe(data => {
                if (data.saveError || data.hasPrimaryReturn == false) {
                    this.handleNetworkError(data.messages);
                } else {
                    this.data = data;
                    this.gridData = data;
                }

                this.setFilteredItemsDisplay();
                this.hideSpinner();
            },
                error => this.handleNetworkError(error));
        } else {
            this.show = true;
            this.hideSpinner();
        }

    }

    handleNetworkError(error) {

        this.hideSpinner();
        this.showError();
    }
    showSpinner() {
        this.loaderState.emit(true);
    }

    hideSpinner() {
        this.loaderState.emit(false);
    }

    showError() {
        this.loaderError = true;
        this.loaderErrorState.emit(this.loaderError);
    }

    hideError() {
        this.loaderError = false;
        this.loaderErrorState.emit(this.loaderError);
    }

    public onToggle(): void {
        this.show = !this.show;
    }

    setDetailData(category?: string) {
        this.showSpinner();
        let filter = new filterItem();
        filter.field = "Status";
        if (category) {
            filter.value = category;
            this.searchParam.out_S = filter.value;
            this.detailsTitle = this.detailsTitleStart + filter.value;
        }
        this.detailsActive = true;
        this.selectedFilters = this.searchParam;
        this.windowData.selectedFilters = this.selectedFilters;
        this.windowData.dashboardQuery = this.dashboardQuery;
        if (this.gridData) {
            this.windowData.gridData = this.gridData;
        }
        this.popWindow();

        this.hideSpinner();
    }

    popWindow() {
        this.activeChildComp = this.contentTypes.chartWidget;
        //this.windowData = {};
        this.showWindow = true;
        this.svc_data.disableDragging = true;
    }

    public onGridButtonClick() {
        this.showSpinner();
        this.setDetailData();
    }

    onClosed(e) {
        this.showWindow = false;
        this.svc_data.disableDragging = false;
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }
    
    setFilteredItemsDisplay() {
        this.customerFilters = CommonFunctions.findInObjArr(this.referenceData.customers, this.searchParam.customerIds);
        this.acctClassFilters = CommonFunctions.findInObjArr(this.referenceData.accountClasses, this.searchParam.classIds);
        this.srvConstFilters = CommonFunctions.findInObjArr(this.referenceData.srvConst, this.searchParam.srvConstInt);
        this.billerFilters = CommonFunctions.findInObjArr(this.referenceData.billers, this.searchParam.billerIds);
        this.daysAgedFilters = CommonFunctions.findInObjArr(this.globals.daysAgedOptions, this.searchParam.daysAged)
        this.dispatchStatusFilters = CommonFunctions.findInObjArr(this.referenceData.dispatchStatus, this.searchParam.statusIds);
        this.locationsFilters = CommonFunctions.findInObjArr(this.referenceData.locations, this.searchParam.locationIds);       
        this.divisionFilters = CommonFunctions.findInObjArr(this.referenceData.divisions, this.searchParam.divisionIds);
        this.regionFilters = CommonFunctions.findInObjArr(this.referenceData.regions, this.searchParam.regionIds);
        this.defaultSubmitterFilters = CommonFunctions.findInObjArr(this.referenceData.personsSel, this.searchParam.defaultSubmitterIds);
    }
}
